import Cookies from "js-cookie";

const BearerToken = Cookies.get("Token");

const CONSTANTS = {
  SESSION_TOKEN: "api_token",
  // API_BASE: "https://chat.imwow.co.in/imwow/api/v1",
  API_BASE: 'https://admin.imwow.co.in/imwow/api/v1',

  // For creating the socket connection
  CHAT_BASE: "https://admin.imwow.co.in:3111",
  // CHAT_BASE: "https://chat.imwow.co.in:3113",
  // DASHBOARD_BASE: "https://chat.imwow.co.in",
  DASHBOARD_BASE: "https://admin.imwow.co.in",
  BearerToken: BearerToken,
};

export default CONSTANTS;
